import type React from 'react';
import styled from 'styled-components';

export const KeyboardSymbol = styled.span`
  min-width: 1.8em;
  line-height: 1.2;
  text-align: center;
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
  color: ${({ theme }) => theme.palette.text.primary};
  background: ${({ theme }) => theme.palette.background.paper};
  padding: ${({ theme }) => theme.spacing(0.25)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

const KeyboardSymbolList = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(0.25)};
`;

const KeyboardShortcut: React.FC<{ readonly keys: string[] }> = ({ keys }) => (
  <KeyboardSymbolList>
    {keys.map((key) => (
      <KeyboardSymbol key={key}>{key}</KeyboardSymbol>
    ))}
  </KeyboardSymbolList>
);

export default KeyboardShortcut;
